import React from 'react'
import img1 from '../../assets/ourApproach/2_Approch link.png'
import img2 from '../../assets/ourApproach/3_Approch link.png'
import img3 from '../../assets/ourApproach/4_Approch link.png'
import img4 from '../../assets/ourApproach/5_Approch link.png'

const OurWays = () => {
  return (
    <div className='text-[#fff]' >
      
      <div className='h-fit overflow-x-hidden no-scrollbar lg:min-h-[100vh] bg-blue-bg bg-cover bg-center flex flex-col items-center gap-12 lg:justify-evenly py-20 lg:py-12 px-6 md:px-12 lg:px-0' >
          <div className='flex flex-col-reverse md:flex-row lg:w-[70%] gap-4 lg:gap-12 items-center' >
            <div className='w-full md:w-[40%] lg:w-[50%] flex flex-col gap-3' >
                <h3 data-aos="fade-right" data-aos-duration="800" className='text-3xl font-mosk600' >Project Management</h3>
                <p data-aos="fade-right" data-aos-duration="950" className='text-lg lg:text-xl' >With a customized timeline, whether the event is virtual, hybrid, or in-person, we facilitate key stakeholders in determining the vision of the event and defining of a successful outcome.</p>
            </div>
            <div className='w-full md:w-[60%] lg:w-[50%] ' >
              <img data-aos="fade-left" className='w-[100%]' src={img1} alt="" />
            </div>
          </div>
          <div className='flex flex-col md:flex-row no-scrollbar lg:w-[70%] gap-4 lg:gap-12 items-center'>
            <div className='w-full md:w-[60%] lg:w-[50%] '>
              <img data-aos="fade-right" className='w-[100%] ' src={img2} alt="" />
            </div>
            <div className='w-full md:w-[40%] lg:w-[50%] no-scrollbar flex flex-col gap-3'>
                <h3 data-aos="fade-left" data-aos-duration="800" className='text-3xl font-mosk600'>Budget Planning</h3>
                <p data-aos="fade-left" data-aos-duration="950" className='text-lg lg:text-xl'>At BlueDoor, we optimize your project’s budget with strategies that save money without compromising quality. We blend skill and innovation to balance intelligence and cost-effectiveness. Our thorough audits ensure wise spending and high ROI, delivering unforgettable experiences. Trust BlueDoor to manage your budget with care and professionalism, backed by our experience and commitment to excellence.</p>
            </div>
          </div>
      </div>

      <div className='h-fit overflow-x-hidden no-scrollbar lg:min-h-[100vh] bg-red-bg bg-cover bg-center  flex flex-col items-center gap-12 lg:justify-evenly py-20 lg:py-12 px-6 md:px-12 lg:px-0' >
        <div className='flex flex-col-reverse md:flex-row lg:w-[70%] gap-4 lg:gap-12 items-center' >
            <div className='w-full md:w-[40%] lg:w-[50%] flex flex-col gap-3' >
                <h3 data-aos="fade-right" data-aos-duration="800" className='text-3xl font-mosk600' >Event Communication</h3>
                <p data-aos="fade-right" data-aos-duration="950" className='text-lg lg:text-xl' >We believe in developing effective, compelling and concise communication strategies throughout the scope of the events along with Pre and Post-event surveys and engagement analytics.</p>
            </div>
            <div className='w-full md:w-[60%]  lg:w-[50%] ' >
              <img data-aos="fade-left" className='w-[100%]' src={img3} alt="" />
            </div>
          </div>
          <div className='flex flex-col md:flex-row lg:w-[70%] no-scrollbar gap-4 lg:gap-12 items-center'>
            <div className='w-[80%] md:w-[50%] lg:w-[50%] '>
              <img data-aos="fade-right" className='m-auto max-w-[100%] max-h-[40vh]' src={img4} alt="" />
            </div>
            <div className='w-full md:w-[40%] lg:w-[50%] flex flex-col gap-3'>
                <h3 data-aos="fade-left" data-aos-duration="800" className='text-3xl font-mosk600'>Experience</h3>
                <p data-aos="fade-left" data-aos-duration="950" className='text-lg lg:text-xl'>We offer the best gourmet experience, considering audience demographics, international attendees, faith-based preferences, and environmental responsibility. We guide menu design and selection within budget parameters, ensuring everyone is fed with minimal waste.</p>
            </div>
          </div>
      </div>

    </div>
  )
}

export default OurWays
